export function getSpotIdFromConversationId(conversationId) {
  if (!conversationId) {
    return null;
  }

  const res = conversationId.match(/(sp_[^_]+)_[^_]+/);

  return res[1];
}

export function getPostIdFromConversationId(conversationId) {
  if (!conversationId) {
    return null;
  }

  const res = conversationId.match(/sp_[^_]+_([^_]+)/);

  return res[1];
}

export function getImageFromFileReader(imageFile) {
  return new Promise(res => {
    const fr = new FileReader();

    fr.onload = function() {
      var img = new Image();

      img.onload = function() {
        res(img);
      };

      img.src = fr.result;
    };

    fr.readAsDataURL(imageFile);
  });
}
